module.exports = __webpack_public_path__ + "static/media/13pic.6b5737b5.jpg";